<script>
import agreementTitle from '@/lib/agreement-title';
// import matterDetails from './matterDetail.json';
import cloneDeep from 'lodash/cloneDeep';
import base from '@/lib/agreement/base.json';
import { analytics, firebaseApp  } from '././firebase';
import { BSpinner } from 'bootstrap-vue'
// import MatterDetailsVue from './components/Agreements/MatterDetails.vue';
// import axios from 'axios';
import vSelect from 'vue-select'

export default {
	name: 'ClioImport',
	components: {
		BSpinner,
		vSelect
	},
	data() {
		return {
            selectedMatterId: '',
			primaryParent: '',
			secondaryContactId:'',
			matterDetails: null,
            agreementData: cloneDeep(base),
			partner1Details:'',
			partner2Details:'',
			loading: false,
			hasSecondaryContact: false,
			partner1:'',
			partner2:'',
			contactData:'',
			partner: '',
			matterList:[],
			secondaryContactList:[],
			selectedMatter:{},
			loadingMatter:false,
			loadingSpouse:false,
			observer: null,
			search: '',
			nextPageUrl: null,
			loadingMoreMatters: false,
		};
	},
	props:['showClioModal', 'hideClioModal', 'saveDetails','title'],
	computed: {

		partnerOptions(){
			this.partner1 = this.selectedMatter.data.name;
			this.partner2 = this.secondaryContactList.find((contact)=> { return contact.value == this.secondaryContactId}).text;
			return [
				{ text: `${this.partner1}`, value: 'partner1' },
				{ text: `${this.partner2}`, value: 'partner2' },
			];
			
		},
		filteredMatters() {
			if (!this.search) {
				return this.matterList;
			}
			return this.matterList.filter((item) => item.text.toLowerCase().includes(this.search.toLowerCase()))
		},
		hasNextPage() {
			return !!this.nextPageUrl;
		},
	},
	methods: {
        agreementTitle,
		matterOptions(){
			this.matterList= [];
			if(this.matterDetails && this.matterDetails.data){
				this.matterDetails.data.forEach(matter=>{
					const matterText = `${matter.display_number}: ${matter.description}`
					this.matterList.push({value:matter.id, text: matterText , fullData: matter})
				})
			}
		},
		appendMatterOptions(mattersData){
			if(mattersData && mattersData.data){
				const newMatters = mattersData.data.map(matter => {
					const matterText = `${matter.display_number}: ${matter.description}`
					return {value:matter.id, text: matterText , fullData: matter};
				});
				const existingIds = new Set(this.matterList.map(m => m.value));
				const uniqueNewMatters = newMatters.filter(m => !existingIds.has(m.value));
				this.matterList = [...this.matterList, ...uniqueNewMatters];
			}
		},
		onMatterSelect(){
			// find the selected matter from the full list to get relationship data
			const selected = this.matterList.find(m => m.value === this.selectedMatterId);

			if (selected) {
				this.selectedMatter = selected.fullData.client;
				if(selected.fullData.relationships && selected.fullData.relationships.length){
					this.hasSecondaryContact=true;
					this.loadingSpouse=true;
					this.clioGetRelatedContacts();
				} else {
					this.hasSecondaryContact=false;
				}
				this.clioClientLink();
			} else {
				this.hasSecondaryContact = false;
			}
		},
		setAdditionalDataOnMatterSelect(){
			if(this.primaryParent){
				if(this.primaryParent=='partner1'){
					this.partner1Details=this.selectedMatter.data;
					this.partner2Details=this.secondaryContactList.find((contact)=> contact.value == this.secondaryContactId ).fullData;
				}else{
					this.partner1Details=this.secondaryContactList.find((contact)=> contact.value == this.secondaryContactId ).fullData;
					this.partner2Details=this.selectedMatter.data;
				}
			}else{
				this.partner1Details=this.selectedMatter.data;
			}
			console.log("Success")
				// Primary Parent details
			if(this.partner1Details){
				this.agreementData.partner1.name.first=this.partner1Details.first_name;
				this.agreementData.partner1.name.middle=this.partner1Details.middle_name;
				this.agreementData.partner1.name.last=this.partner1Details.last_name;
				this.agreementData.partner1.birthdate=this.partner1Details.date_of_birth;
				this.agreementData.partner1.mail=this.partner1Details.primary_email_address;
				if(this.partner1Details.addresses && this.partner1Details.addresses.length){
					this.agreementData.partner1.address.street=this.partner1Details.addresses[0].street;
					this.agreementData.partner1.address.city=this.partner1Details.addresses[0].city;
					this.agreementData.partner1.address.province=this.partner1Details.addresses[0].province;
					this.agreementData.partner1.address.postalCode=this.partner1Details.addresses[0].postal_code;
					this.agreementData.partner1.address.country=this.partner1Details.addresses[0].street;
				}
			}
				// Secondary Parent details
				if(this.primaryParent)
				{
					this.agreementData.partner2.name.first=this.partner2Details.first_name;
					this.agreementData.partner2.name.middle=this.partner2Details.middle_name;
					this.agreementData.partner2.name.last=this.partner2Details.last_name;
					this.agreementData.partner2.birthdate=this.partner2Details.date_of_birth;
					this.agreementData.partner2.mail=this.partner2Details.primary_email_address;
					if(this.partner2Details.addresses && this.partner2Details.addresses.length){
						this.agreementData.partner2.address.street=this.partner2Details.addresses[0].street;
						this.agreementData.partner2.address.city=this.partner2Details.addresses[0].city;
						this.agreementData.partner2.address.province=this.partner2Details.addresses[0].province;
						this.agreementData.partner2.address.postalCode=this.partner2Details.addresses[0].postal_code;
						this.agreementData.partner2.address.country=this.partner2Details.addresses[0].country;
					}
				}
		},
        createAgreement() {
			try{
				this.$emit('isLoading', "true");
				// console.log("clio: ",this.selectedMatterId)
					if(this.selectedMatterId){
						this.setAdditionalDataOnMatterSelect()
					}
				this.loading = true;
				this.$store
					.dispatch('createAgreement', {
						...this.agreementData,
						title: agreementTitle(this.agreementData),
					})
					.then(({ id, error }) => {
						if (error) {
							this.error = 'Something unexpected went wrong.';
						} else if (id) {
							analytics.logEvent('agreement_created');
							this.$router.push({
								name: 'agreement',
								params: { id },
							});
						}
					})
					.catch((err)=>{
						console.error("createAgreement error->",err)
					});
			}catch(error){
				console.error("Error in createAgreement:", error)
			}
		},
		async clioMatterDetailsLink(){
			try
			{
				this.loadingMatter = true;
				const clioMatterDetails = firebaseApp.functions('northamerica-northeast1').httpsCallable('clioApis-matterDetails');
				const accessTokenClio=JSON.parse(localStorage.getItem('cliotoken'))
				let header={
					authorization: accessTokenClio.access_token
				}
				const linkResponse = await clioMatterDetails(header)
				if(linkResponse && linkResponse.data && linkResponse.data.data){
					const details = JSON.parse(linkResponse.data.data);
					this.matterDetails = details;
					this.nextPageUrl = details.meta.paging.next;
					this.matterList = []; // Reset list for initial fetch
					this.appendMatterOptions(details);
				}
			}catch(error){
				console.log("clioMatterDetailsLink error:",error)
			} finally {
				this.loadingMatter = false;
			}
		},
		async clioGetRelatedContacts(){
			try
			{
				const clioRelatedContacts = firebaseApp.functions('northamerica-northeast1').httpsCallable('clioApis-relatedContacts');
				const accessTokenClio=JSON.parse(localStorage.getItem('cliotoken'))
				if(!accessTokenClio || !accessTokenClio.access_token){
					return console.error("No access token")
				} 
				if(!this.selectedMatterId){
					return console.error("No matter Id present")
				}
				let body={
					authorization: accessTokenClio.access_token,
					matterId: this.selectedMatterId
				}
				clioRelatedContacts(body)
						.then(relContactResponse=>{
							if(relContactResponse){
								if(relContactResponse.data && relContactResponse.data && relContactResponse.data.data && JSON.parse(relContactResponse.data.data)){
								// console.log('clioRelatedContacts resp->', JSON.parse(relContactResponse.data.data))
									let relatedContactList = JSON.parse(relContactResponse.data.data);
									if(relatedContactList && relatedContactList.data && relatedContactList.data.length){
										relatedContactList.data.forEach(element => {
											// this.partner2 = `${element.first_name} ${element.last_name}`
											let contactText = `${element.name}`
											this.secondaryContactList.push({value:`${element.id}`, text: contactText, fullData: element})
										});
									}
									this.loadingSpouse = false;
								}
							}
						})
						.catch((err)=>{
							this.loadingSpouse = false;
							console.error("clioGetRelatedContacts error->",err)
						})
			}catch(error){
				this.loadingSpouse = false;
				console.log(" clioGetRelatedContacts error:",error)
			}
		},
		async clioClientLink(){
			try
			{
				const clioClientDetails = firebaseApp.functions('northamerica-northeast1').httpsCallable('clioApis-clioClient');
				const accessTokenClio=JSON.parse(localStorage.getItem('cliotoken'))
				// console.log("acces TOKEN clioClientLink:",accessTokenClio.access_token)
				if(!accessTokenClio || !accessTokenClio.access_token){
					return console.error("No access token")
				} 
				if(!this.selectedMatterId){
					return console.error("No matter Id present")
				}
				let body={
					authorization: accessTokenClio.access_token,
					matterId: this.selectedMatterId
				}
				clioClientDetails(body)
					.then(clientResponse=>{
						if(clientResponse){
							if(clientResponse.data && clientResponse.data.data && JSON.parse(clientResponse.data.data)){
							// console.log('clioClientLink resp->', JSON.parse(clientResponse.data.data))
								let clientDetail = JSON.parse(clientResponse.data.data);
								// relatedContactList.forEach(element => {
								// 	// this.partner2 = `${element.first_name} ${element.last_name}`
								// 	let contactText = `${element.first_name} ${element.last_name}`
								// 	this.secondaryContactList.push({value:`${element.id}`, text: contactText})
								// });
								this.selectedMatter = clientDetail;
							// console.log("clioClientLink format response :", clientDetail)
							}
						}
					})
					.catch((err)=>{
						console.error("clioClientLink error->",err)
					})
			
			}catch(error){
				console.log("error client:",error)
			}
		},
		restoreDropdownScroll(scrollTop) {
			// Find the open dropdown menu
			let menu = null;
			const menus = document.querySelectorAll('.vs__dropdown-menu');
			menus.forEach(m => {
				if (m.offsetParent !== null) menu = m;
			});
			if (menu) {
				menu.scrollTop = scrollTop;
				return true;
			}
			return false;
		},
		async fetchMoreMatters() {
			if (!this.nextPageUrl || this.loadingMoreMatters) return;

			this.loadingMoreMatters = true;

			// Save scroll position
			await this.$nextTick();
			let menu = null;
			const menus = document.querySelectorAll('.vs__dropdown-menu');
			menus.forEach(m => {
				if (m.offsetParent !== null) menu = m;
			});
			const oldScrollTop = menu ? menu.scrollTop : 0;

			try {
				const clioMatterDetails = firebaseApp.functions('northamerica-northeast1').httpsCallable('clioApis-matterDetails');
				const accessTokenClio = JSON.parse(localStorage.getItem('cliotoken'));

				const body = {
					authorization: accessTokenClio.access_token,
					nextPageUrl: this.nextPageUrl
				};

				const linkResponse = await clioMatterDetails(body);

				if (linkResponse && linkResponse.data && linkResponse.data.data) {
					const newMatterDetails = JSON.parse(linkResponse.data.data);
					this.matterDetails = newMatterDetails; 
					this.nextPageUrl = newMatterDetails.meta.paging.next;
					this.appendMatterOptions(newMatterDetails);

					// Use MutationObserver to wait for the menu to be re-rendered
					let attempts = 0;
					const tryRestore = () => {
						if (this.restoreDropdownScroll(oldScrollTop)) {
							observer.disconnect();
						} else if (++attempts > 10) {
							observer.disconnect();
						}
					};

					const observer = new MutationObserver(() => {
						tryRestore();
					});

					observer.observe(document.body, { childList: true, subtree: true });

					// Also try immediately and after a short delay
					this.$nextTick(() => {
						setTimeout(tryRestore, 30);
					});
				}
			} catch (error) {
				console.error('Error fetching more matters:', error);
			} finally {
				this.loadingMoreMatters = false;
			}
		},
		async onOpen() {
			if (this.hasNextPage) {
				await this.$nextTick();
				if (this.$refs.load) {
					this.observer.observe(this.$refs.load);
				}
			}
		},
		onClose() {
			if (this.observer) {
				this.observer.disconnect()
			}
		},
		async infiniteScroll([{ isIntersecting }]) {
			if (isIntersecting) {
				this.fetchMoreMatters();
			}
		},
  
	},
	created(){
		this.observer = new IntersectionObserver(this.infiniteScroll, {
			root: null, 
			rootMargin: '0px',
			threshold: 1.0
		});
	},
	mounted(){
		this.clioMatterDetailsLink();

	},
	destroyed() {
		if (this.observer) {
			this.observer.disconnect();
		}
	}
};
</script>

<template>
	<b-modal
		id="clioImport"
		v-model="showClioModal"
		:title="title"
		@hide="hideClioModal"
		@ok="createAgreement"
	>
		<template #modal-footer="{ ok, cancel }">
			<!-- <b-button size="sm" @click="deleteEditingEvent()" data-testid="delete-editing-event">
				Delete
			</b-button> -->
			<b-button size="sm" variant="navy" @click="cancel()" data-testid="cancel-button"> Cancel </b-button>
			<b-button size="sm" variant="primary" @click="ok()" data-testid="save-button">
				Create agreement
			</b-button>
		</template>
			<b-form-group >
				<b-row>
					<b-col class="mb-3 my-3">Choose a matter to import:</b-col>
					<b-col>
						<b-spinner
						small 
						variant="primary"
						label="Loading..."
						type="grow"
						class="mb-3 my-3"
						v-if="loadingMatter"
						/>
						<!-- <b-form-select
							v-else
							class="mb-3 my-3"
							input-cols="4"
							id="clio-import"
							v-model="selectedMatterId"
							:options="matterList"
							data-testid="import-clio-file"
							v-on:change="onMatterSelect()"
							label="Choose a matter to import"
						/> -->
						<v-select
							v-else
							:options="filteredMatters"
							:filterable="false"
							label="text"
							class="clio-import-dropdown mb-3 my-3"
							data-testid="import-clio-file"
							id="clio-import"
							v-model="selectedMatterId"
							:get-option-key="option => option.value"
							:reduce="option => option.value"
							@input="onMatterSelect"
							@open="onOpen"
							@close="onClose"
							@search="(query) => (search = query)"
							ref="matterSelect"
						>
							<template #list-footer>
							<li v-show="hasNextPage" ref="load" class="loader d-flex align-items-center justify-content-center py-2">
								<b-spinner small v-if="loadingMoreMatters"></b-spinner>
								<!-- <span v-else>Loading more...</span> -->
							</li>
							</template>
						</v-select>
					</b-col>
				</b-row>
					<!-- <div>Choose a matter to import:</div>
					<b-spinner
						small 
						variant="primary"
						label="Loading..."
						type="grow"
						class="spinner-outer"
					/>
                    <b-form-select
						class="mb-3 my-3"
						input-cols="4"
						id="clio-import"
						v-model="selectedMatterId"
						:options="matterOptions"
						data-testid="import-clio-file"
						v-on:change="onMatterSelect()"
						label="Choose a matter to import"
					/> -->
					<b-row v-if="hasSecondaryContact">
						<b-col class="mb-3 my-3">Choose the spouse:</b-col>
						<b-col>
							<b-spinner
								small 
								variant="primary"
								label="Loading..."
								type="grow"
								class="mb-3 my-3"
								v-if="loadingSpouse"
							/>
							<b-form-select
								v-else
								class="mb-3 my-3"
								input-cols="4"
								id="secondary-contact"
								v-model="secondaryContactId"
								:options="secondaryContactList"
								data-testid="secondary-contact-clio"
							/>
						</b-col>
					</b-row>
					<b-row v-if="secondaryContactId && hasSecondaryContact">
						<b-col class="mb-3 my-3">Choose the party 1:</b-col>
						<b-col>
							<b-form-select
							class="mb-3 my-3"
							input-cols="4"
							id="primary-parent"
							v-model="primaryParent"
							:options="partnerOptions"
							data-testid="primary-parent-clio"
							/>
						</b-col>
					</b-row>
				<b-spinner v-if="loading" variant="primary" label="Spinning"></b-spinner>
			</b-form-group>
	</b-modal>
</template>

<style>
@import "../node_modules/vue-select/dist/vue-select.css";


.clio-import-dropdown .vs__dropdown-menu{
	@media (min-width: 1024px){
		width: unset;
	}
}

.loader {
	text-align: center;
	color: #888;
}
</style>